import { timezones } from '@getaccept/lib-shared/src/constants/time-zone.constants';
import { useSessionStore } from '../../session/store/session.store';

const safeKey = (key: string) => key.replace('.', ':');

// Some timezone keys are incorrect in the DB. This should hande most of them.
const fallbackZone = (key: string): string => {
  const sign = key.startsWith('-') ? '-' : '+';
  const absValue = Math.abs(parseInt(key)).toString();
  const paddedValue = absValue.padStart(2, '0');
  return `${sign}${paddedValue}:00`;
};

export const getTimezone = () => {
  const sessionStore = useSessionStore();
  const timezoneKey = sessionStore.session.timezone || '+00:00';

  const { zone } =
    timezones.find(timezone => timezone.key === safeKey(timezoneKey)) ||
    timezones.find(timezone => timezone.key === fallbackZone(timezoneKey)) ||
    timezones.find(timezone => timezone.key === '+00:00');

  return zone;
};
